import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { query } from '@warp-drive/utilities/json-api';
import type { Store } from '@warp-drive/core';
import type Controller from '@ember/controller';
import type { TasPaymentExtension as TasPaymentModel } from 'tio-data/data/resources/tas-payment.ext';
import type SessionContextService from 'tio-employee/services/session-context';
import type PartnerService from 'tio-employee/services/partner';

const PAGE_LIMIT = 50;

type Params = {
  page: number;
  state: string;
};

export default class AuthenticatedAdminTuitionAssistancePaymentsRoute extends Route {
  @service declare sessionContext: SessionContextService;
  @service declare partner: PartnerService;
  @service declare store: Store;

  queryParams = {
    page: { refreshModel: true },
    state: { refreshModel: true },
  };

  setupController(controller: Controller, model: TasPaymentModel[]) {
    super.setupController(controller, model);
    const params = this.paramsFor(this.routeName);
    if (params.state) {
      controller.set('state', params.state);
    }
  }

  async model(params: Params) {
    const { page, state } = params;

    const company = this.partner.company?.id as string;
    const offset = ((page || 1) - 1) * PAGE_LIMIT;

    const { content } = (await this.store.request(
      query<TasPaymentModel>('tas-payment', {
        'filter[company]': company,
        'filter[state]': state,
        'page[limit]': PAGE_LIMIT,
        'page[offset]': offset,
      })
    )) as { content: { data: TasPaymentModel[]; meta?: { page?: { total?: number } } } };

    return {
      tasPayments: content.data,
      total: content.meta?.page?.total,
    };
  }
}
